import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IVariantPersonaDiscountsUpdateBody } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export type PersonaDiscountsUpdateReturn = {
  status: boolean;
  message: string;
};

export const useVariantPersonaDiscountsUpdateAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (body: IVariantPersonaDiscountsUpdateBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: PersonaDiscountsUpdateReturn = await axios
          .put(`${INVENTORY_MODULE?.VARIANT_PERSONA_DISCOUNTS_API?.baseURL}`, body, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<{ status: boolean; message: string }>) => {
            if (res.data.status === true) {
              toast.success("Persona discounts updated");
              return { status: true, message: "Updated" };
            } else {
              return { status: false, message: res.data.message || "Update failed" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "Update failed" };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return { status: false, message: e?.message ?? "Update failed" };
      }
    },
    [dispatch],
  );

  return execute;
};
